import { DynamicCircularService } from "./api";
import { DYNAMIC_CIRCULAR_TYPES } from "../../../types";
import { init, success, finish, remove, error } from "services/common";

const dynamicCircularService = new DynamicCircularService();

//Dynamic Circular Service
// added
export const actionForGetAllCircularPlanningTemplate = () => {
  return async (dispatch) => {
    dispatch(init(DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE));
    const response =
      await dynamicCircularService.getAllCircularPlanningTemplate();
    if (response.isSuccess) {
      dispatch(
        success(
          DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE,
          response.data
        )
      );
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
    dispatch(finish(DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_TEMPLATE));
  };
};

export const actionForGetCircularPlanningCompanyDtos = (id) => {
  return async (dispatch) => {
    console.log("ANIL ACTION");
    dispatch(
      init(DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE)
    );
    const response = await dynamicCircularService.getCircularPlanningCompany(
      id
    );
    if (response.isSuccess) {
      dispatch(
        success(
          DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE,
          response.data
        )
      );
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
    dispatch(
      finish(DYNAMIC_CIRCULAR_TYPES.GET_ALL_CIRCULARPLANNING_COMPANY_TEMPLATE)
    );
  };
};

// post
export const actionForAddCircularPlanningTemplate = (body) => {
  return async (dispatch) => {
    dispatch(init(DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE));
    const response = await dynamicCircularService.addCircularPlanningTemplate(
      body
    );
    if (response.isSuccess) {
      dispatch(
        success(
          DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE,
          response.data
        )
      );
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
    dispatch(finish(DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_TEMPLATE));
  };
};

// updated
export const actionForUpdateCircularPlanningCompany = (body) => {
  return async (dispatch) => {
    dispatch(init(DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY));
    const response = await dynamicCircularService.updateCircularPlanningCompany(
      body
    );
    if (response.isSuccess) {
      dispatch(
        success(
          DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY,
          response.data
        )
      );
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }
    dispatch(finish(DYNAMIC_CIRCULAR_TYPES.UPDATED_CIRCULARPLANNING_COMPANY));
  };
};

// updated
export const actionForAddCircularPlanningCompanyFromList = (body) => {
  return async (dispatch) => {
    dispatch(
      init(DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST)
    );
    try {
      const response =
        await dynamicCircularService.addCircularPlanningCompanyFromList(body);

      if (response.isSuccess) {
        // Create the company data with all required fields
        const companyData = {
          id: response.data.id || body.companyId,
          companyId: body.companyId,
          companyName: body.companyName,
          isActive: true,
          priority: body.priority || 1,
          attentionTo: body.attentionTo || "[]",
          modeofCommunication: body.modeofCommunication || "Email",
          remarks: body.remarks || "",
          country: body.country || "",
          circularPlanningTemplateId: body.circularPlanningTemplateId,
        };

        // Dispatch success with the complete company data
        dispatch(
          success(
            DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST,
            companyData
          )
        );

        // Get updated company list
        await dispatch(
          actionForGetCircularPlanningCompanyDtos(
            body.circularPlanningTemplateId
          )
        );

        return { isSuccess: true, data: companyData };
      } else {
        dispatch(error(response.errorMessage));
        return { isSuccess: false, errorMessage: response.errorMessage };
      }
    } catch (error) {
      console.error(
        "Error in actionForAddCircularPlanningCompanyFromList:",
        error
      );
      dispatch(error(error.message));
      return { isSuccess: false, errorMessage: error.message };
    } finally {
      dispatch(
        finish(DYNAMIC_CIRCULAR_TYPES.ADD_CIRCULARPLANNING_COMPANY_FROM_LIST)
      );
    }
  };
};
